import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import NoResultsPage from '../../../components/no-results-page/NoResultsPage';
import Table from '../../../components/table/Table';
import TBody from '../../../components/table/TBody/TBody';
import TD from '../../../components/table/TD/TD';
import TH from '../../../components/table/TH/TH';
import THead from '../../../components/table/THead/THead';
import TR from '../../../components/table/TR/TR';
import { Project } from '../../../core/state/project/types';
import { RootState } from '../../../core/state/state';
import TableWrapper from '../../components/table-wrapper/TableWrapper';
import Image from '../../../components/image/Image';
import { BASE_URL } from '../../../core/constants/api';
import { getExternalUserProjects } from '../../../core/state/project/asyncActions';

import './ExternalUserProjects.scss';

const ExternalUserProjects: React.FC = () => {
  const { t } = useTranslation();
  const { userId } = useParams<{ userId: string }>();
  const dispatch = useDispatch();
  const projects = useSelector((state: RootState) => state.projects.externalUserProjects);

  React.useEffect(() => {
    dispatch(getExternalUserProjects(Number(userId)));
  }, [dispatch, userId]);

  return (
    <TableWrapper>
      <div className="table__header">
        <span>{t('externalUsers.companyProjects.title')}</span>
      </div>
      <div className="external-user-projects__table">
        <Table>
          <THead>
            <TR>
              <TH>{t('common.projectName')}</TH>
              <TH>{t('common.projectNumber')}</TH>
              <TH>{t('common.constructionArea')}</TH>
            </TR>
          </THead>
          <TBody>
            {projects?.map((project: Project) => (
              <TR key={`${project.id}`}>
                <TD className="d-flex align-items-center">
                  <Image className="project-listing__project-img" src={`${BASE_URL}/${project.photo}`} alt={project.photo} />
                  <div className="font-weight-bold">{project.name}</div>
                </TD>
                <TD className="text-left">
                  <div className="table__text">{project.code}</div>
                </TD>
                <TD className="text-left">
                  <div className="table__text">{project.constructionSite}</div>
                </TD>
              </TR>
            ))}
          </TBody>
        </Table>
        {!projects && <NoResultsPage title={t('common.noProjects')} description={t('internalUsers.noProjects.description')} icon="projects" />}
      </div>
    </TableWrapper>
  );
};

export default ExternalUserProjects;
